<template>
  <Modal v-model="visible" :title="satementData.reconciliationName" :footer-hide="true" :mask-closable="false" width="99%"
    class="my-modal top">
    <div class="content">
      <Tabs v-model="tabs" @on-click="changeTab">
        <TabPane :label="item.tabName + '（' + item.num + '）'" :name="item.tabName" v-for="(item, index) in tabData"
          :key="index"></TabPane>
      </Tabs>
      <div class="firstTable" v-if="summaryData.length > 0">
        <div class="tableHead">
          <div class="headItem"></div>
          <div class="headItem">记录数合计</div>
          <div class="headItem">保费合计</div>
          <div class="headItem">费用合计</div>
          <div v-if="satementData.reconciliationType == 1" class="headItem">首期基础费用合计</div>
          <div v-if="satementData.reconciliationType == 1" class="headItem">首期限时加费合计</div>
          <div v-if="satementData.reconciliationType == 4" class="headItem">续期基础费用合计</div>
          <div v-if="satementData.reconciliationType == 4" class="headItem">续年服务津贴合计</div>
        </div>
        <div class="tableRow" v-for="(item, index) in summaryData" :key="index">
          <div class="header">{{ item.type }}</div>
          <div class="rowItem">{{ item.totalNumber || '0' }}</div>
          <div class="rowItem">{{ item.totalFee || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}">{{ item.totalCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 1">{{ item.totalBaseCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 1">{{ item.totalActCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 4">{{ item.totalRenewBaseCommission || '0' }}
          </div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 4">{{ item.totalRenewAllowance || '0' }}</div>
        </div>
      </div>
      <div class="search-tools">
        <div class="search-box btn3">
          <div class="input-item">
            <span class="label">保单号</span>
            <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
          </div>
          <Button type="primary" @click="getList()">搜索</Button>
          <Button type="primary" ghost @click="daochu()">导出系统数据</Button>
        </div>
      </div>
      <Table :columns="columns" :data="tableData" id="tableBox">
        <template slot-scope="{ row, index }" slot="action">
          <div class="detail">
            <span v-if="row.isCompulsory == '1'">已强平</span>
          </div>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange"
          style="text-align: center" />
      </div>
    </div>
  </Modal>
</template>

<script>
import { pageTool } from "@/api/mixins";

export default {
  mixins: [pageTool],
  data() {
    return {
      visible: false,
      searchParams: {},
      tabs: '汇总',
      summaryData: [],
      satementData: {},// 对账单数据
      tabData: {},
      columns: [
      {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          width: "180",
          fixed: "left",
        },
        {
          title: "保单年度",
          align: "center",
          key: "commissionIndex",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '交费期次',
          key: 'commissionPeriods',
          align: 'center',
          width: "100",
        },
        {
          title: '保险产品',
          key: 'productName',
          align: 'center',
          width: "200",
        },
        {
          title: '险种名称',
          key: 'productTypeName',
          align: 'center',
          width: "200",
        },
        {
          title: '保单状态',
          key: 'policyStatus',
          align: 'center',
          width: "100",
        },
        {
          title: '承保日期',
          key: 'insureTime',
          align: 'center',
          width: "200",
        },
        {
          title: '生效日期',
          key: 'effectTime',
          align: 'center',
          width: "200",
        },
        {
          title: '实收日期',
          key: 'actualReceiveTime',
          align: 'center',
          width: "200",
        },
        {
          title: '保障期',
          key: 'guaranteeValueDesc',
          align: 'center',
          width: "100",
        },
        {
          title: '交费期',
          key: 'payValueDesc',
          width: "140",
          align: 'center',
        },
        {
          title: '对比结果',
          key: 'comparisonStatus',
          width: "180",
          align: 'center',
        },
        {
          title: '保费',
          align: 'center',
          children: [
            {
              title: '系统保费',
              key: 'fee',
              width: "120",
              align: 'center',
            },
            {
              title: '供应商保费',
              key: 'supplierFee',
              width: "120",
              align: 'center',
            },
          ]
        },
        {
          title: '费率',
          align: 'center',
          children: [
            {
              title: '系统费率',
              key: 'commission',
              align: 'center',
              width: "120",
              render(h, params) {
                  return <span>{Number(params.row.commission) ? params.row.commission : '-'}</span>;
              }
            },
            {
              title: '供应商费率',
              key: 'supplierCommission',
              align: 'center',
              width: "120",
              render(h, params) {
                  return <span>{Number(params.row.supplierCommission) ? params.row.supplierCommission : '-'}</span>;
              }
            },
          ]
        },
        {
          title: '费用',
          align: 'center',
          children: [
            {
              title: '系统费用',
              key: 'commissionPrice',
              align: 'center',
              width: "120",
            },
            {
              title: '供应商费用',
              key: 'supplierCommissionPrice',
              align: 'center',
              width: "120",
            },
          ]
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "200",
          fixed: "right",
        },
      ]
    }
  },
  methods: {
    daochu() {
      if(this.$units.pointAction('offline_8_2_5')){
        this.loading = true;
        this.$http({
          url: "/buz/molCommissionConsult/exportDetailsPageByCheckId",
          type: "POST",
          responseType: "blob",
          data: {
            checkId: this.satementData.id,
            tabs:this.tabs,
            ...this.searchParams
          },
        })
          .then((res) => {
            this.loading = false;
            this.$units.daochu(res);
          })
          .catch((e) => {
            this.loading = false;
          });
        }else{
          this.$Message.error('无权操作，请联系您的上级')
        }
    },
    changeTab() {
      this.pageNo = 1
      this.getSummaryData()
      this.getList()
    },
    getColumns() {
      if (this.satementData.reconciliationType == 1 || this.satementData.reconciliationType == 2) {
        let idx = ''
        idx = this.columns.findIndex(item => item.key == 'commissionIndex')
        this.columns.splice(idx, 1);
        idx = this.columns.findIndex(item => item.key == 'actualReceiveTime')
        this.columns.splice(idx, 1);
      }
      window.setTimeout(()=>{
        document.getElementById("tableBox").querySelectorAll(".ivu-table-body")[0].scrollLeft = document.getElementById("tableBox").querySelectorAll(".ivu-table-body")[0].scrollWidth 
      },300)
    },
    listCallback(res) {
      // isOk，对比状态（0待对比；1一致，2费用不一致，3供应商没有的记录，4系统未生成费用，5系统无此保单）
      // isCompulsory，是否强平（0否，1是）
      res.data.forEach(item => {
          if (item.isCompulsory == 1) {
            item.cellClassName = {
              commission: 'demo-table-cell-name2',
              supplierCommission: 'demo-table-cell-name2',
              commissionPrice: 'demo-table-cell-name2',
              supplierCommissionPrice: 'demo-table-cell-name2',
            }
          } 
          if (item.isOk == 2) {
            item.cellClassName = {
              commission: 'demo-table-cell-name1',
              supplierCommission: 'demo-table-cell-name1',
              commissionPrice: 'demo-table-cell-name1',
              supplierCommissionPrice: 'demo-table-cell-name1',
            } 
        }
      });
    },
    //获取汇总数据
    getSummaryData() {
      this.$http({
        url: '/buz/molCommissionConsult/summaryTabs',
        type: 'POST',
        data: {
          checkId: this.$route.query.id || this.checkId,
          tabs: this.tabs,
        },
      }).then((res) => {
        if (res.data) {
          this.summaryData = res.data
        }
      })
    },
    getTabs() {
      this.$http({
        url: '/buz/molCommissionConsult/queryTabsInfo',
        type: 'POST',
        data: {
          checkId: this.satementData.id,
        },
      }).then((res) => {
        if (res.data) {
          this.tabData = res.data
          this.tabs = this.tabData[0].tabName
        }
      })
    },
    open(item) {
      this.satementData = item
      this.visible = true
      this.getTabs()
      this.tabs = '汇总'
      this.getSummaryData()
      this.initListAjax('/buz/molCommissionConsult/detailsPageByCheckId')
      this.getColumns()
    },
    setListParams(params) {
      params.tabs = this.tabs;
      params.checkId = this.satementData.id;
    },
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-table .demo-table-cell-name1 {
  background-color: #E3461F;
  color: #fff;
}
/deep/ .ivu-table .demo-table-cell-name2 {
  background-color: #F59045;
  color: #fff;
}
/deep/ .ivu-table-body{
  width: 100%;
}
/deep/.ivu-btn-ghost{
    background: #FFF !important;
    color: #236DFF !important;
    border: 1px solid #236DFF !important;
}
.red{
  color: #E3461F;
}
.orange{
  color: #F59045;
}
.content {
  width: 100%;

  .firstTable {
    margin-top: 12px;
    margin-bottom: 20px;

    .tableHead {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      flex: 1;
      height: 40px;
      background: #F7F7F7;
      border: 1px solid #E3E5E8;

      .headItem {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;

        &:not(:last-child) {
          border-right: 1px solid #E3E5E8;
        }
      }
    }

    .tableRow {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      flex: 1;
      height: 40px;

      div {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-left: 1px solid #E3E5E8;
        border-bottom: 1px solid #E3E5E8;

        &:last-child {
          border-right: 1px solid #E3E5E8;
        }
      }

      .header {
        display: inline-block;
        background: #F7F7F7;
      }

    }
  }

}

.pageBox {
  margin-top: 20px;
}

/deep/ .ivu-table-tip table {
  min-height: 380px;
}
</style>